import React from "react";
import { Loader2, AlertTriangle, RotateCcw } from "lucide-react";

export function Loading({ text = "Yükleniyor...", className = "py-10" }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-2 text-slate-500 text-sm ${className}`} data-testid="loading-state" role="status">
      <Loader2 size={26} className="animate-spin text-emerald-600" />
      <span className="font-medium">{text}</span>
    </div>
  );
}

export function LoadingRow({ colSpan, text }) {
  return <tr><td colSpan={colSpan}><Loading text={text} /></td></tr>;
}

export function LoadError({ text = "Veriler yüklenemedi.", onRetry, className = "py-10" }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-2 text-sm ${className}`} data-testid="load-error-state" role="alert">
      <AlertTriangle size={24} className="text-rose-500" />
      <span className="font-semibold text-rose-700">{text}</span>
      <span className="text-xs text-slate-500">Bağlantı yavaş olabilir, lütfen tekrar deneyin.</span>
      {onRetry && (
        <button type="button" onClick={onRetry} data-testid="load-error-retry-btn"
          className="mt-1 inline-flex items-center gap-1.5 bg-slate-900 hover:bg-slate-700 text-white px-3 py-1.5 rounded-lg text-xs font-bold">
          <RotateCcw size={13} /> Tekrar Dene
        </button>
      )}
    </div>
  );
}
